import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ShareModalState {
  visible: boolean;
  files: any[];
}

const initialState: ShareModalState = {
  visible: false,
  files: [],
};

const shareModalSlice = createSlice({
  name: "shareModal",
  initialState,
  reducers: {
    openShareModal(state, action: PayloadAction<any[]>) {
      state.visible = true;
      state.files = action.payload;
    },
    closeShareModal(state) {
      state.visible = false;
      state.files = [];
    },
  },
});

export const { openShareModal, closeShareModal } = shareModalSlice.actions;
export default shareModalSlice.reducer;
